import {http} from '@/utils/http'
import {ISmartSearchFilterInterface} from "@/features/search/search.types";

const cleanSearchParams = (params: any) => {
    return Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v !== null && v !== undefined)
    )
}


export const searchService = {
    smartSearch(filter: ISmartSearchFilterInterface, signal?: AbortSignal) {
        return http.get('/search/smart', {
            params: cleanSearchParams(filter),
            signal
        })
    },
}